module.exports = __webpack_public_path__ + "img/btn3.d759475f.png";